import { useCallback, useState } from "react";

export default function useToggleIndex() {
  const [index, setIndex] = useState<number | null>(null);

  const toggle = useCallback((value: number) => {
    setIndex((prev) => (prev === value ? null : value));
  }, []);

  return { index, setIndex, toggle };
}
